import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  DISPLAY_FEATURE_NOTIFICATION: '3722',
  LEARN_MORE: '3723',
  DISMISS_NOTIFICATION: '3724',
  DISMISS_ALL_NOTIFICATIONS: '3725',
} as const;

// https://dataportal.zillowgroup.net/event-registry/3722
export const emitDisplayFeatureNotificationEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.DISPLAY_FEATURE_NOTIFICATION,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'impression',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'feature_notification',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3723
export const emitLearnMoreEvent = ({
  user,
  triggerObject = 'no_trigger_object',
}: {
  user?: ZrmClickstreamUser | null;
  triggerObject?: string;
}) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.LEARN_MORE,
      event_type_version_id: '3',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'learn_more',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'click_feature_notification',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3724
export const emitDismissNotificationEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.DISMISS_NOTIFICATION,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'x_x',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'dismiss_notification',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3725
export const emitDismissAllNotificationsEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.DISMISS_ALL_NOTIFICATIONS,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'x_x',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'dismiss_all_notifications',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });
